export const sliderPtV1 = {
  elements: Array.from(
    document.querySelectorAll(".slider-pt--v1 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    cssMode: true,
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 0,
    speed: 800,
    threshold: 10,
    // longSwipesRatio: 2,
    resistance: false,

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.closest(".slider-pt").querySelector(".swiper-button-next"),
      prevEl: el.closest(".slider-pt").querySelector(".swiper-button-prev"),
    },
    // breakpoints: {
    //   1023: {
    //     slidesPerView: 2,
    //     spaceBetween: 40,
    //   },
    //   640: {
    //     slidesPerView: 1,
    //     spaceBetween: 20,
    //   },
    // },
  }),
};